var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInstagram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#98918A",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.915 0h-6.86A5.062 5.062 0 0 0 0 5.056v6.859a5.061 5.061 0 0 0 5.056 5.055h6.859a5.061 5.061 0 0 0 5.055-5.055v-6.86A5.062 5.062 0 0 0 11.915 0zm3.348 11.915c0 1.849-1.5 3.348-3.348 3.348h-6.86a3.349 3.349 0 0 1-3.348-3.348v-6.86c0-1.849 1.5-3.348 3.349-3.348h6.859c1.849 0 3.348 1.5 3.348 3.349v6.859z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.485 4.096a4.394 4.394 0 0 0-4.389 4.39 4.393 4.393 0 0 0 4.39 4.388c2.42 0 4.388-1.969 4.388-4.389s-1.969-4.389-4.389-4.389zm0 7.071a2.682 2.682 0 1 1 0-5.363 2.682 2.682 0 0 1 0 5.363z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12.883,
  cy: 4.129,
  r: 1.052
}))));
export default SvgInstagram;